import React from "react";
import MovieCard from "./MovieCard";
import { Movie } from "../../store/slices/moviesSlice";
import { ChevronRight } from "lucide-react";

interface MovieListProps {
  title: string;
  movies: Movie[] | null;
}

const MovieList: React.FC<MovieListProps> = ({ title, movies }) => {
  if (!movies) return null;

  return (
    <div className="relative group/list py-4">
      <div className="flex items-center space-x-2 px-2 mb-4 group/title cursor-pointer">
        <h2 className="text-xl md:text-2xl font-black text-gray-200 tracking-tight transition-all duration-300 group-hover/title:text-white group-hover/list:translate-x-1">
          {title}
        </h2>
        <ChevronRight size={24} className="text-red-600 opacity-0 -translate-x-2 group-hover/title:opacity-100 group-hover/title:translate-x-0 transition-all duration-300" />
      </div>

      <div className="flex overflow-x-auto scrollbar-hide space-x-3 pb-6 snap-x px-2">
        {movies.map((movie) => (
          <div key={movie.id} className="snap-start">
            <MovieCard
              movieId={movie.id}
              posterPath={movie.poster_path}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MovieList;
